export default {
  to: "/dashboard/upgrade-list",
  order: 2,
  icon: "mdi-trending-up",
  title: "Upgrade Applications",
  sublinks: [
    {
      to: `/dashboard/upgrade/list`,
      order: 1,
      title: "My Upgrades",
      disabled: false,
      icon: "mdi-account-arrow-up-outline",
    },
    {
      to: `/dashboard/upgrade/open/interviews`,
      order: 2,
      title: "New interviews",
      disabled: false,
      icon: "mdi-calendar-plus",
    },
    {
      to: `/dashboard/upgrade/scheduled/interviews`,
      order: 3,
      title: "Scheduled interviews",
      disabled: false,
      icon: "mdi-calendar-clock",
    },
    {
      to: `/dashboard/upgrade/reports`,
      order: 4,
      title: "Reports",
      disabled: false,
      icon: "mdi-chart-box-outline",
    },
  ],
};
